if (!customElements.get('paperwallet-utility-widget')) {
  class PaperwalletUtilityWidget extends HTMLElement {
    connectedCallback() {
      this.hideNativeIntercomLauncher();
      this.smileButton = this.querySelector('[data-paperwallet-utility-action="smile"]');
      this.smileReady = false;
      this.setupSmileButton();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    disconnectedCallback() {
      if (this.smileObserver) {
        this.smileObserver.disconnect();
      }
    }

    handleClick(event) {
      const control = event.target.closest('[data-paperwallet-utility-action]');
      if (!control || !this.contains(control)) return;

      const action = control.dataset.paperwalletUtilityAction;

      if (action === 'chat') {
        this.openIntercom();
      }

      if (action === 'smile') {
        this.openSmilePanel();
      }

      if (action === 'top') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }

    setupSmileButton() {
      if (!this.smileButton) return;

      this.updateSmileReady();

      this.smileObserver = new MutationObserver(() => {
        this.updateSmileReady();
      });

      this.smileObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    updateSmileReady() {
      const isReady = this.isSmileReady();

      if (isReady === this.smileReady) return;

      this.smileReady = isReady;
      this.smileButton.disabled = !isReady;
    }

    isSmileReady() {
      return Boolean(
        document.querySelector('.smile-launcher-frame-container') ||
        document.querySelector('#smile-launcher-frame-container') ||
        document.querySelector('#smile-ui-lite-container') ||
        document.querySelector('#smile-ui-container')
      );
    }

    openSmilePanel() {
      if (!this.smileReady) return;

      if (window.location.hash === '#smile-home') {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      window.requestAnimationFrame(() => {
        window.location.hash = 'smile-home';
      });
    }

    hideNativeIntercomLauncher() {
      window.intercomSettings = window.intercomSettings || {};
      window.intercomSettings.hide_default_launcher = true;

      if (typeof window.Intercom === 'function') {
        window.Intercom('update', {
          hide_default_launcher: true
        });
      }
    }

    openIntercom(attempt) {
      const currentAttempt = attempt || 0;

      this.hideNativeIntercomLauncher();

      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      if (currentAttempt < 10) {
        window.setTimeout(() => this.openIntercom(currentAttempt + 1), 200);
      }
    }
  }

  customElements.define('paperwallet-utility-widget', PaperwalletUtilityWidget);
}
